import { mdiProgressQuestion } from "@mdi/js";
import type { SESSION_STATUS } from "../../types";

export const getButtonIconAndLabel = (
	status: SESSION_STATUS,
	showReport?: boolean,
) => {
	switch (status) {
		case "ACTIVE":
			return {
				icon: "play-pause" as const,
				label: "Resume",
				mode: "outlined" as const,
				progressIcon: "progress-question" as const,
				mdiProgressIcon: mdiProgressQuestion,
			};
		case "COMPLETE":
			return {
				icon: "poll" as const,
				label: showReport ? "View Report" : "",
				mode: "text" as const,
				progressIcon: "checkbox-marked-outline" as const,
				mdiProgressIcon: null,
			};
		case "NOT_STARTED":
			return {
				icon: "play-outline" as const,
				label: "Start",
				mode: "contained" as const,
				progressIcon: "progress-question" as const,
				mdiProgressIcon: mdiProgressQuestion,
			};
		default:
			return null;
	}
};
